import marketingInstance from '../instance'

const fetchFlyerCoupons = () => {
	return marketingInstance.get('/flyerCoupons')
}

export default fetchFlyerCoupons
